import React from 'react'
import './Match.scss'
import WeatherStats from '../components/WeatherStats'
import GroundStats from '../components/GroundStats'
import useTranslation from '../useTranslation'

export default function Match({ lineups, teams, foregroundColor, backgroundColor, gameType }) {

    const Lineup = useTranslation('Lineup')
    const TeamMember = useTranslation('Team Member')
    const BatHand = useTranslation('Bat Hand')
    const BowlStyle = useTranslation('Bowl Style')

    if (! teams || ! teams[0].players || ! teams[1].players) {
        return (
            <div className="match">
                No team data available
            </div>
        )
    }

    return (
        <div className="match">
            { gameType !== 'QUANTUM' && <WeatherStats lineups={lineups} foregroundColor={foregroundColor} backgroundColor={backgroundColor}/> }

            <GroundStats lineups={lineups} foregroundColor={foregroundColor} backgroundColor={backgroundColor}/>

            {teams.map((team, index) => {
                if (! team.players || team.players.length < 1) return null;
                return (
                    <div key={index}>
                        <div className="team-name" style={{
                            backgroundColor: foregroundColor,
                            color: backgroundColor
                        }}>{team.name} {Lineup}</div>
                        <div className="match-table">
                            <div className="match-table-header">
                                <div className="match-table-cell">{TeamMember}</div>
                                { gameType === 'KABD' || gameType === 'VRKBD' ? 
                                    ( 
                                        <div className="match-table-cell">Role</div>
                                    ) : (
                                        <>
                                            <div className="match-table-cell">{BatHand}</div>
                                            <div className="match-table-cell">{BowlStyle}</div>
                                        </>
                                    )
                                }
                            </div>
                            { team.players.map(({ name, bat_hand, bowler_style }, i) => (
                                <div className="match-table-row" key={name + i}>
                                    <div className="match-table-cell">{name}</div>
                                    { gameType === 'KABD' || gameType === 'VRKBD' ? 
                                    (
                                        <div className="match-table-cell">
                                            {bat_hand}
                                        </div>
                                    ) : (
                                        <>
                                            <div className="match-table-cell">{bat_hand}</div>
                                            <div className="match-table-cell">{bowler_style !== "0" ? bowler_style : ""}</div>
                                        </>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                )
            })}
        </div>
    )
}
